import { Injectable } from '@angular/core';
import { SendTwoFactorAuthOtp } from './send.two.factor.auth.otp.service';
import { TitledModalWithContentService } from '../titled-modal-with-content.service';

@Injectable({
  providedIn: 'root',
})
export class TwoFactorAuthOtpService {
  exceptions = [
    'InvalidOtpException',
    'ExpiredOtpException',
    'AlreadyUsedOtpException',
    'MessageProviderException'
  ];

  constructor(
    private sendTwoFactorAuthOtp: SendTwoFactorAuthOtp,
    private dialog: TitledModalWithContentService
  ) {}

  isOtpException(error: { faultyRequest: any; }): boolean {
    const errorName = error.faultyRequest.error.name;
    const found = errorName
      ? this.exceptions.find((exception) => exception === errorName)
      : false;
    return !!found;
  }

  async sendOtp(operation: string, msgProvider: MsgProvider = "SMS") {
    this.sendTwoFactorAuthOtp.setParams({
      operation,
      msgProvider
    });

    await this.sendTwoFactorAuthOtp.make();
  }

  handleErrors(error: { faultyRequest: { error: { name: string; message: string }; }; }) {
    const isOtpError = this.isOtpException(error);
    if (!isOtpError) {
      return isOtpError;
    }

    const errorName = error.faultyRequest.error.name;
    let errorObject = null;

    if (errorName) {
      switch (errorName) {
        case 'InvalidOtpException':
          errorObject = {
            title: 'Invalid OTP',
            content: 'You have entered an invalid OTP.',
            closeButtonName: 'Close',
          };
          break;
        case 'ExpiredOtpException':
          errorObject = {
            title: 'Expired OTP',
            content: 'Your OTP has been expired.',
            closeButtonName: 'Close',
          };
          break;
        case 'AlreadyUsedOtpException':
          errorObject = {
            title: 'Invalid OTP',
            content: 'This OTP has been used before.',
            closeButtonName: 'Close',
          };
          break;
      }
    }

    if(error.faultyRequest.error.message?.includes("WhatsApp")){
      errorObject = {
        title: 'Provider Error',
        content: error.faultyRequest.error.message,
        closeButtonName: 'Close',
      }
    }
    if (errorObject) this.dialog.open(errorObject);
    return isOtpError;
  }
}


export type MsgProvider = "SMS" | "WHATSAPP";
